import styled from 'styled-components';
import theme from 'styles/theme';

export const DataLinkageModifyPageWrapper = styled.div`
  min-height: calc(100vh - 60px);
  background: #f7f7f7;

  .wrapBox {
    padding: 0 35px 30px 35px;
    background: #fff;

    h2 {
      margin-bottom: 20px;
      padding: 41px 0 18px;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      text-align: center;
      color: ${theme.color.black};

      @media screen and (max-width: 375px) {
        font-size: 14px;
      }
    }

    dl {
      position: relative;
      margin-bottom: 25px;

      dt {
        margin-bottom: 10px;
        text-align: left;
        line-height: 24px;
        font-size: 16px;
        font-weight: 500;
        color: ${theme.color.black};
        white-space: pre-line;

        @media screen and (max-width: 375px) {
          font-size: 14px;
        }
      }

      dd {
        p {
          text-align: left;
          line-height: 24px;
          font-size: 16px;
          color: ${theme.color.black};
          white-space: pre-line;

          @media screen and (max-width: 375px) {
            font-size: 14px;
          }
        }

        &.buttonGroup {
          position: absolute;
          top: 0;
          right: 0;

          button {
            font-size: ${theme.fontSize.h4};
            font-weight: ${theme.fontWeight.normal};
            color: ${theme.color.blue};

            &:disabled {
              color: ${theme.color.policyGrey};
            }

            & + button {
              &::before {
                content: '|';
                display: inline-block;
                margin: 0 5px;
              }
            }
          }
        }
      }

      &.accountSection {
        margin-bottom: 40px;

        & > dd {
          dl {
            dt {
              margin: 15px 0;
              padding-left: 5px;
              font-size: 15px;
              font-weight: 500;

              @media screen and (max-width: 375px) {
                font-size: 13px;
              }
            }
          }
        }
      }

      &.secondAuthSection {
        margin-bottom: 50px;
      }
    }

    section {
      position: relative;
      padding: 20px;
      border-radius: 10px;
      background: ${theme.backgroundColor.contentBox};
      color: ${theme.color.black};

      p {
        &.title {
          padding: 3px 0 10px;
          font-size: 13px;
          font-weight: ${theme.fontWeight.bold};

          @media screen and (max-width: 375px) {
            font-size: 12px;
          }
        }
        &.description {
          font-size: ${theme.fontSize.h5};
          line-height: 23px;
          margin: 10px 0 0 0;

          @media screen and (max-width: 375px) {
            font-size: 12px;
          }
        }
      }

      .toggleBox {
        position: absolute;
        top: 16px;
        right: 22px;
      }
    }
  }
`;

export const ReplaceModalContainer = styled.div`
  padding: 0 10px;

  & > p:first-child {
    margin-bottom: 35px;
  }

  span {
    font-weight: 700;
  }

  .subGuide {
    span,
    li {
      color: #78797c;
    }
  }
`;

export const DirectModalContainer = styled.p`
  span {
    font-weight: 700;
  }
`;
